import { inject, Injectable, OnDestroy } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, Data, Event, NavigationEnd, Router } from "@angular/router";
import { Subject, takeUntil } from "rxjs";
import { filter, map, switchMap } from "rxjs/operators";

@Injectable()
export class PageTitleService implements OnDestroy {
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly titleService = inject(Title);

  private readonly destroySubject = new Subject<void>();

  ngOnDestroy(): void {
    this.destroySubject.next();
    this.destroySubject.complete();
  }

  init(): void {
    this.router.events
      .pipe(
        filter((event: Event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((activatedRoute: ActivatedRoute) => {
          let resultRoute = activatedRoute;
          while (resultRoute.firstChild) {
            resultRoute = resultRoute.firstChild;
          }
          return resultRoute;
        }),
        switchMap((activatedRoute: ActivatedRoute) => activatedRoute.data),
        map((data: Data) => data["title"] as string),
      )
      .pipe(takeUntil(this.destroySubject))
      .subscribe((routeTitle: string) => {
        this.titleService.setTitle(`${routeTitle} - BakerStreet`);
      });
  }
}
